import {
  FiArrowRight,
  FiActivity,
  FiTrendingUp,
  FiCheckCircle,
  FiZap,
} from "react-icons/fi";
import { SiPreact } from "react-icons/si";
import AuditForm from "./AuditForm";

const HomePage = () => {
  const capabilities = [
    {
      icon: <FiZap className="h-5 w-5 text-blue-600" />,
      title: "Lighthouse Analysis",
      description:
        "Comprehensive performance auditing using Google Lighthouse with real-world conditions and metrics.",
    },
    {
      icon: <FiTrendingUp className="h-5 w-5 text-blue-600" />,
      title: "Performance Insights",
      description:
        "Detailed analysis of performance metrics with clear scoring and recommendations for improvement.",
    },
    {
      icon: <FiActivity className="h-5 w-5 text-blue-600" />,
      title: "Core Web Vitals",
      description:
        "Track Core Web Vitals and performance indicators that impact user experience and SEO.",
    },
  ];

  const metrics = [
    "First Contentful Paint (FCP)",
    "Largest Contentful Paint (LCP)",
    "Time to Interactive (TTI)",
    "Total Blocking Time (TBT)",
    "Cumulative Layout Shift (CLS)",
    "Speed Index",
  ];

  return (
    <div className="min-h-screen bg-gray-10">
      {/* Header */}
      <header className="bg-gray-100 border-b border-gray-30">
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <div className="bg-blue-600 p-2">
                <SiPreact className="h-5 w-5 text-white" />
              </div>
              <h1 className="text-heading-04 text-white font-ibm">
                ReactSpeedAudit
              </h1>
            </div>
            <div className="text-white text-label-01 uppercase tracking-wide">
              React Performance Auditing Platform
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-6 py-8">
        {/* Hero Section */}
        <section className="mb-12">
          <div className="max-w-4xl">
            <h2 className="text-heading-05 text-gray-100 mb-4 font-ibm">
              Audit your React application performance
            </h2>
            <p className="text-body-02 text-gray-70 mb-6 max-w-2xl">
              Get comprehensive performance insights and detailed optimization
              recommendations for your deployed React applications.
            </p>
          </div>
        </section>

        {/* Audit Form Section */}
        <section className="mb-12">
          <div className="max-w-2xl">
            <div className="card-elevated">
              <AuditForm />
            </div>
          </div>
        </section>

        {/* Capabilities Grid */}
        <section className="mb-12">
          <h3 className="text-heading-03 text-gray-100 mb-6 font-ibm">
            Capabilities
          </h3>
          <div className="grid lg:grid-cols-3 gap-4">
            {capabilities.map((capability, index) => (
              <div key={index} className="tile">
                <div className="flex items-start space-x-3">
                  <div className="flex-shrink-0 mt-1">{capability.icon}</div>
                  <div>
                    <h4 className="text-heading-02 text-gray-100 mb-2 font-ibm">
                      {capability.title}
                    </h4>
                    <p className="text-body-01 text-gray-70">
                      {capability.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Performance Metrics */}
        <section className="mb-8">
          <div className="bg-white p-6 border-l-4 border-blue-600">
            <h3 className="text-heading-03 text-gray-100 mb-6 font-ibm">
              Performance metrics tracked
            </h3>
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
              {metrics.map((metric, index) => (
                <div key={index} className="flex items-center space-x-3">
                  <FiCheckCircle className="h-4 w-4 text-green-60 flex-shrink-0" />
                  <span className="text-body-01 text-gray-70">{metric}</span>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>

      {/* Call to Action */}
      <section className="bg-gray-90 py-12">
        <div className="max-w-7xl mx-auto px-6">
          <div className="max-w-4xl">
            <h3 className="text-heading-04 text-white mb-4 font-ibm">
              Ready to optimize your React app?
            </h3>
            <p className="text-body-02 text-gray-30 mb-6">
              Start your performance audit today and get actionable insights to
              improve your application's speed and user experience.
            </p>
            <button className="btn-secondary bg-transparent border-white text-white hover:bg-white hover:text-black flex items-center space-x-2">
              <span>Get started</span>
              <FiArrowRight className="h-4 w-4" />
            </button>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-100 border-t border-gray-30">
        <div className="max-w-7xl mx-auto px-6 py-6">
          <p className="text-label-01 text-gray-60 text-center">
            Built by David Zorto || React Performance Expert
          </p>
        </div>
      </footer>
    </div>
  );
};

export default HomePage;
